import { Injectable, inject } from '@angular/core';
import { LocalstorageService, PlatformService } from 'ngx-unificator/services';
import { WA_WINDOW } from 'ngx-unificator/tokens';

@Injectable({
  providedIn: 'root',
})
export class UserStorageRedirectService {

  private _storage = inject(LocalstorageService);
  private _window = inject(WA_WINDOW);
  private _platform = inject(PlatformService);

  public addRedirectRoute() {
    if (this._platform.isBrowser) {
      this._storage.set('STORAGE_REDIRECT_URL', this._window.location.pathname);
    }
  }

  public removeRedirectRoute() {
    if (this._platform.isBrowser) {
      this._storage.clearItem('STORAGE_REDIRECT_URL');
    }
  }

  public getRedirectRoute() {
    return this._platform.isBrowser ? this._storage.get('STORAGE_REDIRECT_URL') : null;
  }

}
